import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { classNamesConfig } from "../../../Shared/features/classnames";
import { Link } from "./library/link";
import { Teasers } from "./teaser";
export class ContentGridBlock extends React.Component {
    render() {
        const p = this.props;
        const className = classNamesConfig().content_grid;
        return /*#__PURE__*/ _jsxs("section", {
            className: `block block--content-grid ${className.block}`,
            children: [
                p.title && p.title != "" && /*#__PURE__*/ _jsx("header", {
                    className: `block__header ${className.inner}`,
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: p.title
                    })
                }),
                /*#__PURE__*/ _jsx(Teasers, {
                    items: p.items.map((i, k)=>({
                            key: `content-grid-item-${k}`,
                            extraClasses: 'block__item col-xs-12 col-sm-6 col-md-4',
                            headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
                            title: i.title,
                            linkUrl: i.linkUrl,
                            intro: i.subtitle,
                            label: i.label,
                            imageUrl: i.imageUrl,
                            imageUrlFallback: i.imageUrlFallback,
                            imageUrlLarge: i.imageUrlLarge,
                            imageAlt: i.imageAlt,
                            video: i.video
                        })).toList()
                }),
                p.primaryActionTitle && p.primaryActionUrl && /*#__PURE__*/ _jsx("footer", {
                    className: `block__actions ${className.inner}`,
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: "button button--primary button--arrow",
                        url: p.primaryActionUrl,
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "button__label",
                            children: p.primaryActionTitle
                        })
                    })
                })
            ]
        });
    }
}
{}